import ParentsEdit from "./assessmentEdit/ParentsEdit";
import { getAppId, getSearchInfo, getSysId } from '../../../shared/utils/storage';
import { FaEdit, FaIdBadge } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

const ContactPeople = () => {
  const [application, setApplication] = useState()

  useEffect(() => {
    const searchedData = getSearchInfo()
    if (searchedData) {
      setApplication(searchedData?.data)
    }
  }, [])
  //const data = useLocation().state
  const emergencyInfo = application?.ContactEmergency[0]

  const styles = {
    h4: {
      color: '#850505',
      textTransform: 'uppercase',
    }
  };



  return (
    <>
      <table id="viewTable">
        <tr>
          <th colspan="3">
            <h4>
              <b>First Emergence Person</b>
            </h4>
          </th>
          <th
            style={{
              textAlign: "right",
              border: "1px",
            }}
          >
            <b>
              <FaIdBadge style={{ fontSize: "23px" }} />
            </b>
            {/* <ParentsEdit /> */}
          </th>
        </tr>
        <tr>
          <td style={{ width: "25%" }}>
            Jina kamili: <br />{" "}
            <h4 style={styles.h4}>{emergencyInfo?.E1FullName}</h4>
          </td>
          <td style={{ width: "25%" }}>
            Uhusiano: <br />{" "}
            <h4 style={styles.h4}>{emergencyInfo?.E1RelationShip}</h4>
          </td>
          <td style={{ width: "25%" }}>
            Kazi: <br />{" "}
            <h4 style={styles.h4}>
              {emergencyInfo?.E1Job}
            </h4>
          </td>
          <td style={{ width: "25%" }}>
            Namba Ya Simu: <br />{" "}
            <h4 style={styles.h4}>
              {emergencyInfo?.E1PhoneNumber}
            </h4>
          </td>
        </tr>
        <tr>
          <td>
            Mkoa: <br />{" "}
            <h4 style={styles.h4}>
              {emergencyInfo?.E1City}
            </h4>
          </td>

          {/* <td>
            Wilaya: <br />
            <h4 style={styles.h4}>{emergencyInfo?.FatherDistrictID}</h4>
          </td> */}
          <td>
            Kata/Shehia: <br />
            <h4 style={styles.h4}>{emergencyInfo?.E1Street}</h4>
          </td>
          <td>
            Nambari ya nyumba: <br />
            <h4 style={styles.h4}>{emergencyInfo?.E1HouseNo}</h4>
          </td>
        </tr>
        <tr>
          <td colspan="4"></td>
        </tr>

      </table>
      <table id="viewTable">
        <tr>
          <th colspan="3">
            <h4>
              <b>Second Emergence Person</b>
            </h4>
          </th>
          <th
            style={{
              textAlign: "right",
              border: "1px",
            }}
          >
            <b>
              <FaIdBadge style={{ fontSize: "23px" }} />
            </b>
            {/* <ParentsEdit /> */}
          </th>
        </tr>
        <tr>
          <td style={{ width: "25%" }}>
            Jina kamili: <br />{" "}
            <h4 style={styles.h4}>{emergencyInfo?.E2FullName}</h4>
          </td>
          <td style={{ width: "25%" }}>
            Uhusiano: <br />{" "}
            <h4 style={styles.h4}>{emergencyInfo?.E2RelationShip}</h4>
          </td>
          <td style={{ width: "25%" }}>
            Kazi: <br />{" "}
            <h4 style={styles.h4}>
              {emergencyInfo?.E2Job}
            </h4>
          </td>
          <td style={{ width: "25%" }}>
            Namba Ya Simu: <br />{" "}
            <h4 style={styles.h4}>
              {emergencyInfo?.E2PhoneNumber}
            </h4>
          </td>
        </tr>
        <tr>
          <td>
            Mkoa: <br />{" "}
            <h4 style={styles.h4}>
              {emergencyInfo?.E2City}
            </h4>
          </td>

          {/* <td>
            Wilaya: <br />
            <h4 style={styles.h4}>{emergencyInfo?.FatherDistrictID}</h4>
          </td> */}
          <td>
            Kata/Shehia: <br />
            <h4 style={styles.h4}>{emergencyInfo?.E2Street}</h4>
          </td>
          <td>
            Nambari ya nyumba: <br />
            <h4 style={styles.h4}>{emergencyInfo?.E2HouseNo}</h4>
          </td>
        </tr>
        <tr>
          <td colspan="4"></td>
        </tr>

      </table>
    </>
  );
}

export default ContactPeople;
